export default "__VITE_ASSET__Dh1sWP_6__"